import instance from "../root.api";

export const getProfileData = () =>
    instance.get(`/users/profile`).then((response) => ({response}));

export const updateProfileRequest = (data) =>
    instance.put(`/users/profile`, data).then((response) => ({response}));
